import React from "react";

function LogoDark() {
  return (
    <svg
      width="70"
      height="49"
      viewBox="0 0 70 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.7719 11.5007C40.9881 10.2815 41.7406 8.59914 41.7406 6.7404C41.7406 3.01794 38.7226 0 35.0001 0C32.6467 0 30.5777 1.20817 29.372 3.03593C29.0517 3.35671 2.21949 36.4282 1.96866 36.8084C0.752489 38.0276 0 39.7104 0 41.5682C0 45.2911 3.01794 48.3091 6.7404 48.3091C9.0938 48.3091 11.1629 47.1014 12.3686 45.2731C12.6889 44.9524 39.5211 11.8804 39.7719 11.5007Z"
        fill="black"
      />
      <path
        d="M55.2974 27.1946C56.5171 25.9745 57.271 24.2901 57.271 22.4289C57.271 18.7064 54.2531 15.6885 50.5306 15.6885C48.1762 15.6885 46.1061 16.8976 44.9005 18.7269C44.5777 19.0502 30.4848 36.4218 30.2325 36.8046C29.0128 38.0248 28.2588 39.7091 28.2588 41.5698C28.2588 45.2928 31.2767 48.3108 34.9992 48.3108C37.3536 48.3108 39.4237 47.1016 40.6289 45.2723C40.9517 44.9495 55.0451 27.5774 55.2974 27.1946Z"
        fill="black"
      />
      <path
        d="M70.0002 6.7404C70.0002 10.4634 66.9822 13.4808 63.2598 13.4808C59.5368 13.4808 56.5193 10.4634 56.5193 6.7404C56.5193 3.01794 59.5368 0 63.2598 0C66.9822 0 70.0002 3.01794 70.0002 6.7404Z"
        fill="black"
      />
      <path
        d="M13.4808 6.7404C13.4808 10.4634 10.4629 13.4808 6.7404 13.4808C3.01794 13.4808 0 10.4634 0 6.7404C0 3.01794 3.01794 0 6.7404 0C10.4629 0 13.4808 3.01794 13.4808 6.7404Z"
        fill="black"
      />
    </svg>
  );
}

export default LogoDark;
